export const tableColumnList = [
  {
    field: 'productCode', // 1
    title: '类别代码',
    width: '160',
    editRender: {
      name: 'productCode',
    },
  },
  {
    field: 'productCategary',
    title: '商品类别',
    width: '150',
    editRender: { name: 'productCategary' },
  },
  {
    field: 'purchaseAmtMonth',
    title: '本月购进额(万元)',
    width: '160',
    editRender: {
      name: 'purchaseAmtMonth',
    },
  },
  {
    field: 'saleAmtMonth',
    title: '本月销售额(万元)',
    width: '160',
    editRender: {
      name: 'saleAmtMonth',
    },
  },
  {
    field: 'purchaseAmt',
    title: '本年累计购进额(万元)',
    width: '160',
    editRender: {
      name: 'purchaseAmt',
    },
  },
  {
    field: 'saleAmt',
    title: '本年累计销售额(万元)',
    width: '160',
    editRender: {
      name: 'saleAmt',
    },
  },
  {
    field: 'inventory',
    title: '期末库存额(万元)',
    width: '160',
    editRender: {
      name: 'inventory',
    },
  },
  {
    field: 'inventoryYearInit',
    title: '期初库存额(万元)',
    width: '160',
    editRender: { name: 'inventoryYearInit' },
  },

  {
    field: 'remark',
    title: '备注',
    width: '200',
    editRender: { name: 'remark' },
  },
];

export const tableRules = {
  // productCategary: [{ required: true, message: '商品类别不能为空' }],
  // purchaseAmt: [{ required: true, message: '本年累计购进额不能为空' }],
  // saleAmt: [{ required: true, message: '本年累计销售额不能为空' }],
  // inventory: [{ required: true, message: '本年累计期末库存额不能为空' }],
  // inventoryYearInit: [{ required: true, message: '本年累计期初库存额不能为空' }],
};
